import { useRef, useState } from "react";

export function SignaturePad({ onChange }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [has, setHas] = useState(false);

  const point = (e) => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * (c.width / r.width), y: (t.clientY - r.top) * (c.height / r.height) };
  };
  const start = (e) => {
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    const p = point(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    if (e.cancelable) e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = point(e);
    ctx.lineTo(p.x, p.y);
    ctx.strokeStyle = "#0F172A";
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.stroke();
    setHas(true);
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    ref.current.toBlob((b) => onChange(new File([b], "firma.png", { type: "image/png" })), "image/png");
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setHas(false);
    onChange(null);
  };

  return (
    <div>
      <canvas ref={ref} width={480} height={150} data-testid="signature-canvas"
        className="w-full border border-input rounded-sm bg-white touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <button type="button" onClick={clear} data-testid="clear-signature-btn" className="text-xs text-muted-foreground mt-1 hover:text-foreground">
        {has ? "Limpiar firma" : "Firma aquí con el dedo o mouse (opcional)"}
      </button>
    </div>
  );
}
